var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29 0H4C1.79086 0 0 1.79086 0 4V29C0 31.2091 1.79086 33 4 33H29C31.2091 33 33 31.2091 33 29V4C33 1.79086 31.2091 0 29 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11C13.0166 11 11.5666 11.4399 10.3332 12.264C9.09986 13.0881 8.13856 14.2594 7.57091 15.6299C7.00325 17.0003 6.85472 18.5083 7.14411 19.9632C7.4335 21.418 8.14781 22.7544 9.1967 23.8033C10.2456 24.8522 11.582 25.5665 13.0368 25.8559C14.4917 26.1453 15.9997 25.9968 17.3701 25.4291C18.7406 24.8614 19.9119 23.9001 20.736 22.6668C21.5601 21.4334 22 19.9834 22 18.5H14.5V11Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.5H25C25 13.5109 24.2098 11.6032 22.8033 10.1967C21.3968 8.79018 19.4891 8 17.5 8V15.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularChartIcon);
export default __webpack_public_path__ + "static/media/circularChartIcon.16f4e9b69aa16d3aae616f3697d5ecdb.svg";
export { ForwardRef as ReactComponent };